import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgWand = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.52 2a.75.75 0 0 1 .75.75v2.077a.75.75 0 0 1-1.5 0V2.75a.75.75 0 0 1 .75-.75m5.376 2.665a.75.75 0 1 0-1.061-1.06L17.45 4.988a.75.75 0 1 0 1.061 1.06zm-4.154 4.154a.75.75 0 1 0-1.06-1.06L2.22 20.218a.75.75 0 1 0 1.06 1.061zm2.931-.588a.75.75 0 0 0 0 1.5h2.077a.75.75 0 0 0 0-1.5zm-1.915 2.989a.75.75 0 0 1 1.06 0l1.385 1.384a.75.75 0 0 1-1.06 1.061l-1.385-1.385a.75.75 0 0 1 0-1.06m-5.862-6.923a.75.75 0 0 0-1.061 1.06l1.384 1.385a.75.75 0 0 0 1.061-1.06z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgWand;
